import * as L from '../styles/SubscriptionTableStyles';
import { RouteComponentProps } from 'react-router';
import SubscriptionTableLogic from './SubscriptionTableLogic';
import DocumentTitle from 'react-document-title';
import React, { useEffect, useState } from 'react';
import ServiceSubscriptionTableLogic from './ServiceSubscriptionTableLogic';
import { Separator } from '@fluentui/react';
import Auth from '@/Auth/Auth';
import SubscriptionService, { UserSubscriptionsType } from '@/services/SubscriptionService';

interface RouteParams { };
interface Props extends RouteComponentProps<RouteParams> { };

export const SubscriptionProfile: React.FunctionComponent<Props> = (props, context) => {
    const user = Auth.getUserProfile();
    const [subscriptions, setSubscriptions] = useState<UserSubscriptionsType[]>();
    const [services, setServices] = useState<UserSubscriptionsType[]>();
    const [loading, setLoading] = useState(true);

    const callAPIValues = async () => {
        let data = await SubscriptionService.getSubscriptionByUser(user.id);
        if (data !== undefined) {
            setSubscriptions(data.filter(item => item.subscriptionType !== 'subscription'));
            setServices(data.filter(item => item.subscriptionType === 'service'));
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        callAPIValues();
    }, []);

    return (
        <React.Fragment>
            <DocumentTitle title="IronIA - Suscripciones y Pagos">
                <L.Wrapper>
                    <L.TitleContainer>
                        <L.Title>Suscripciones y Pagos</L.Title>
                    </L.TitleContainer>
                    <Separator />
                    <SubscriptionTableLogic subscriptions={subscriptions} loading={loading} />
                </L.Wrapper>
            </DocumentTitle>
            <ServiceSubscriptionTableLogic subscriptions={services} loading={loading} />
        </React.Fragment>
    );
};